import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push, replace } from 'connected-react-router'

import MainView from '../components/MainView/MainView'
import { setDevice } from '../../../modules/device/actions/creators'
import { setAccessToken } from '../../../modules/auth/actions/creators'
import { setStep } from '../../../modules/registration/actions/creators'
import { setAccountStatus } from '../../../modules/profile/actions/creators'
import { setFirstSpinModalOpen } from '../../../modules/gamification/actions/creators'
import { doVerifyOtp, doResendOtp } from '../../../controllers/Registration'

const mapStateToProps = reduxState => {
  const { registration, profile, auth, device } = reduxState
  const { primaryInfo } = profile
  const { token, step } = registration
  const { firebaseMessagingToken } = auth
  const { browser } = device

  return {
    primaryInfo,
    token,
    step,
    firebaseMessagingToken,
    doVerifyOtp,
    doResendOtp,
    browser,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setStep,
      push,
      replace,
      setAccessToken,
      setAccountStatus,
      setDevice,
      setFirstSpinModalOpen,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
